import DatePicker from "components/disw/DatePicker";
import { ValueChangedEvent } from "devextreme/ui/select_box";
import React from "react";
import { Period } from "./helpers/updateDateRange";
import SelectComboBox from "./SelectComboBox";

type TimePeriods = {
  id: Period;
  name: string;
};
type TimePeriodSelectionProps = {
  selectedPeriod?: Period;
  handlePeriodChange: (e: ValueChangedEvent) => void;
  startDate?: Date;
  endDate?: Date;
  handleDateRangeChange: (value: Array<Date | undefined>) => void;
};
const TimePeriodSelection: React.FC<TimePeriodSelectionProps> = ({
  handleDateRangeChange,
  handlePeriodChange,

  selectedPeriod,
  startDate,
  endDate
}) => {
  const timePeriods: TimePeriods[] = [
    { id: "all_time", name: "All Time" },
    { id: "last_week", name: "Last Week" },
    { id: "last_month", name: "Last Month" },
    { id: "last_6_months", name: "Last 6 Months" },
    { id: "last_year", name: "Last Year" },
    { id: "custom", name: "Custom" }
  ];

  return (
    <>
      <SelectComboBox<TimePeriods>
        items={timePeriods}
        displayExpr="name"
        valueExpr="id"
        value={selectedPeriod}
        onValueChanged={handlePeriodChange}
        placeholder="Select a period of time"
        label="Period of time"
      />
      {selectedPeriod === "custom" && (
        <DatePicker
          startDate={startDate}
          endDate={endDate}
          handleDateRangeChange={handleDateRangeChange}
          label="Date Range"
        />
      )}
    </>
  );
};

export default TimePeriodSelection;
